import { z, type ZodType } from 'zod';

import type { JsonPrimitive } from './types/json';

const getTypeName = (schema: ZodType): string | undefined => {
  return (schema as { _def?: { typeName?: string } })._def?.typeName;
};

export const isZodString = (schema: ZodType): schema is z.ZodString => {
  return schema instanceof z.ZodString || getTypeName(schema) === 'ZodString';
};

export const isZodNumber = (schema: ZodType): schema is z.ZodNumber => {
  return schema instanceof z.ZodNumber || getTypeName(schema) === 'ZodNumber';
};

export const isZodBoolean = (schema: ZodType): schema is z.ZodBoolean => {
  return schema instanceof z.ZodBoolean || getTypeName(schema) === 'ZodBoolean';
};

export const isZodAny = (schema: ZodType): schema is z.ZodAny => {
  return schema instanceof z.ZodAny || getTypeName(schema) === 'ZodAny';
};

export const isZodEnum = (
  schema: ZodType,
): schema is z.ZodEnum<[string, ...string[]]> => {
  return schema instanceof z.ZodEnum || getTypeName(schema) === 'ZodEnum';
};

export const isZodLiteral = (
  schema: ZodType,
): schema is z.ZodLiteral<unknown> => {
  return schema instanceof z.ZodLiteral || getTypeName(schema) === 'ZodLiteral';
};

export const isZodArray = (
  schema: ZodType,
): schema is z.ZodArray<z.ZodTypeAny> => {
  return schema instanceof z.ZodArray || getTypeName(schema) === 'ZodArray';
};

export const isJsonPrimitive = (value: unknown): value is JsonPrimitive => {
  return (
    value === null || ['string', 'number', 'boolean'].includes(typeof value)
  );
};
